import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {StatusListener} from '../../../status-listener';
import * as $ from 'jquery';
import {MenuPage} from '../../../../shared-gen/Model/Menus/MenuPage';
import {AppService} from '../../../services/app.service';


@Component({
	selector: 'page-menu',
	templateUrl: './page-menu.component.html',
	styleUrls: ['./page-menu.component.scss']
})
export class PageMenuComponent extends StatusListener implements OnInit, OnDestroy {

	@Input() pages: MenuPage[] = [];
	@Input() currentPage: number = 0;
	@Output() currentPageChange: EventEmitter<number> = new EventEmitter();
	@Output() onChange: EventEmitter<MenuPage> = new EventEmitter();

	constructor(app: AppService) {
		super(app);
	}

	async click(page: number) {
		if (this.currentPage != page) {
			this.currentPageChange.next(page);
			this.onChange.next(this.pages[page]);
		}
	}
}
